import Input from './Input';
import PhoneInput from './PhoneInput';
import PassInput from './PassInput';
import DateInput from './DateInput';
import Textarea from './Textarea';
import BirthdayInput from './BirthdayInput';

export default Input;

export {
  Input,
  PhoneInput,
  PassInput,
  DateInput,
  BirthdayInput,
  Textarea,
}
